import React from 'react';
import i18n from '../i18n';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[FunnelHack ErrorBoundary]', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div
        data-testid="app-error-boundary"
        style={{
          minHeight: '100vh', background: '#050505', color: '#fff',
          display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        }}
      >
        <div style={{ maxWidth: 520, textAlign: 'center' }}>
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 56, height: 56, borderRadius: 16, background: 'rgba(239,68,68,0.12)',
            border: '1px solid rgba(239,68,68,0.4)', fontSize: 26, marginBottom: 20,
          }}>
            ⚠️
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 700, margin: '0 0 10px' }}>
            {i18n.t('errb.title')}
          </h1>
          <p style={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.6, margin: '0 0 20px', fontSize: 14 }}>
            {i18n.t('errb.body')}
          </p>
          <pre
            data-testid="app-error-detail"
            style={{
              background: '#121212', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12,
              padding: 14, fontSize: 11, color: '#F87171', textAlign: 'left',
              whiteSpace: 'pre-wrap', wordBreak: 'break-word', maxHeight: 160, overflow: 'auto',
              margin: '0 0 24px',
            }}
          >
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button
            data-testid="app-error-reload-btn"
            onClick={() => window.location.reload()}
            style={{
              padding: '12px 28px', background: 'linear-gradient(135deg,#2563EB,#3B82F6)',
              color: '#fff', border: 'none', borderRadius: 10, fontWeight: 600,
              fontSize: 14, cursor: 'pointer',
            }}
          >
            {i18n.t('errb.reload')}
          </button>
        </div>
      </div>
    );
  }
}
